//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      activeId: "",
      zhhlxh: require("../assets/zhhlxh.png"),
      logoImg: require("../assets/logo.png"),
      zsList: [],
      disabled: false,
      showPositionValue: false,
      loading: false,
      overLoading: false,
      errorMsg: "",
      type: "5",
      footer: {
        title: "more",
        // url: 'http://vux.li'
      },
      results: [],
      list: [],
      count: 0,
      allPageCount: 0,
      pageInfo: {
        pageSize: 5,
        pageIndex: 1,
      },
      searchFilter: {
        param: "",
        activeId: "",
        activeYear: String(new Date().getFullYear()),
      },
    };
  },
  computed: {},
  async mounted() {
    this.activeId = this.$route.params.activeId;
    if (!this.activeId) {
      this.activeId = this.$route.params.id;
    }
    await this.queryTopSwiper(this.activeId);
    await this.queryList();
  },
  methods: {
    /**
     * @Description: 获取轮播
     * @Param:
     * @Author: chen_yong
     * @Version: 1.0.0
     * @Date: 2020-07-31 20:39:17
     */
    async queryTopSwiper(id) {
      const url = this.$apis.exhibition.getSwiper;
      try {
        const { data } = (await this.$axios.get(`${url}/${id}`)) || {};
        this.handlerZsList(data);
      } catch (err) {
        this.showMsg(err.data.msg);
      }
    },

    /**
     * @Description: 处理下轮播
     * @Param:
     * @Author: chen_yong
     * @Version: 1.0.0
     * @Date: 2020-07-31 17:45:32
     */
    handlerZsList(swipers) {
      let temList = new Array();
      if (swipers) {
        for (let i = 0; i < swipers.length; i++) {
          const temp = {};
          temp.img = swipers[i].url;
          this.zsList[i] = temp;
        }
      }
    },

    resultClick(item) {
      this.searchFilter.param = item.title;
      this.list = [];
      this.pageInfo.pageSize = 5;
      this.pageInfo.pageIndex = 1;
      this.queryList();
    },
    /**
     * 搜索数据
     */
    getResult(val) {
      if (val) {
        this.searchFilter.param = val;
        this.results = [];
        this.searchList();
      } else {
      }
    },
    onCancel() {
      if (this.loading) {
        // do nothing
      } else {
        this.list = [];
        this.pageInfo.pageSize = 5;
        this.pageInfo.pageIndex = 1;
        this.queryList();
      }
    },
    onFocus() {},
    onSubmit() {
      console.log("aaaa");
      this.$refs.search.setBlur();
      this.$vux.toast.show({
        type: "text",
        position: "top",
        text: "on submit",
      });
    },
    /**
     * 选择tab更新数据
     */
    onItemClick(index) {
      if (this.loading) {
        // do nothing
      } else {
        this.loading = true;
        this.$refs.scrollerBottom.reset({ top: 0 });
        this.searchFilter.isBefore = index + 1;
        this.list = [];
        this.pageInfo.pageSize = 5;
        this.pageInfo.pageIndex = 1;
        this.queryList();
        this.loading = false;
      }
    },
    /**
     * 下拉加载
     */
    onScroll(pos) {
      this.scrollTop = pos.top;
    },
    /**
     * 上拉加载
     *
     */
    onScrollBottom() {
      if (this.loading) {
        // do nothing
      } else {
        this.loading = true;
        if (this.allPageCount > this.pageInfo.pageIndex) {
          this.pageInfo.pageIndex = this.pageInfo.pageIndex + 1;
          this.queryList();
          setTimeout(() => {
            this.loading = false;
          }, 2000);
        } else {
          this.loading = false;
          this.overLoading = true;
          setTimeout(() => {
            this.overLoading = false;
          }, 1200);
        }
      }
    },
    /**
     * 获取所有活动信息
     *
     */
    async queryList(param = {}) {
      this.loading = true;
      const list = this.$apis.exhibition.stores;
      const params = Object.assign({}, this.pageInfo, this.searchFilter, param);
      try {
        const { data } = (await this.$axios.post(list, params)) || {};
        this.count = data.count;
        this.allPageCount = Math.ceil(data.count / this.pageInfo.pageSize);
        for (var i = 0; i < data.list.length; i++) {
          var val = data.list[i];
          this.list.push({
            src: val.storeLogo ? val.storeLogo : "1",
            fallbackSrc:
              "https://nursevideo.oss-cn-beijing.aliyuncs.com/common/piclose.png",
            title: val.storeName,
            desc: val.content,
            url: "/storedetail/" + val.id + "/" + val.activeId,
            meta: {
              source: "展位",
              date: val.storeLocation,
              other: "",
            },
          });
        }
        this.loading = false;
      } catch (err) {
        this.showMsg(err.data.msg);
        this.loading = false;
      }
    },
    /**
     * 获取所有活动信息
     *
     */
    async searchList(param = {}) {
      this.loading = true;
      const list = this.$apis.exhibition.stores;
      const params = Object.assign({}, this.pageInfo, this.searchFilter, param);
      try {
        const { data } = (await this.$axios.post(list, params)) || {};
        for (var i = 0; i < data.list.length; i++) {
          var val = data.list[i];
          this.results.push({
            src: val.storeLogo ? val.storeLogo : "1",
            fallbackSrc:
              "https://nursevideo.oss-cn-beijing.aliyuncs.com/common/piclose.png",
            title: val.storeName,
            desc: val.content,
            url: "/index/" + val.id,
          });
          this.loading = false;
        }
      } catch (err) {
        this.showMsg(err.data.msg);
        this.loading = false;
      }
    },
    /**
     * 显示提示信息
     *
     */
    showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/storelist.vue